export enum StoragePrefix {
  USER = 'user',
  MAP_FILTER = 'map_filter',
  REMEMBER_ME = 'remember_me',
  SIDEBAR_COLLAPSED = 'sidebar_collapsed',
  MAP_CENTER = 'map_center',
}

export const localStorageHelper = {
  get: <T>(key: StoragePrefix): T => {
    return JSON.parse(window.localStorage.getItem(key) as string) as T;
  },
  set: <T>(key: StoragePrefix, value: T): void => {
    window.localStorage.setItem(key, JSON.stringify(value));
  },
  clear: (key: StoragePrefix): void => {
    window.localStorage.removeItem(key);
  },
};

export const sessionStorageHelper = {
  get: <T>(key: StoragePrefix): T => {
    return JSON.parse(window.sessionStorage.getItem(key) as string) as T;
  },
  set: <T>(key: StoragePrefix, value: T): void => {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  },
  clear: (key: StoragePrefix): void => {
    window.sessionStorage.removeItem(key);
  },
};
